import type { AttachmentDownload } from "@shared/models/analytics/attachment"
import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import { getPossessiveForPlanbook } from "@shared/models/analytics/planbook"
import type { CardAttachment } from "@shared/models/card-stack"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "@shared/actions/create-narrative"
import defaultLessonActivity from "../lesson/default-lesson-activity"
import defaultLessonContext from "../lesson/default-lesson-context"
import defaultLessonModels from "../lesson/default-lesson-models"

interface Payload {
  cardStackId: string
  attachment: CardAttachment
}

export default function downloadAttachmentAction(payload: Payload): PreparedAction {
  return {
    name: "DOWNLOAD_ATTACHMENT",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

export function narrative(payload: Payload, findFn: FindFn, userId: string): Narrative {
  let models = defaultLessonModels(payload, findFn, userId)
  let context = defaultLessonContext(payload, models)
  let newEvent: AttachmentDownload = {
    ...createBlankEvent(),
    root_id: models.cardStack?.relationships.planbook?.data?.id,
    root_type: "planbook",
    date_plan_scheduled_for: models.dateStringForCardStack,
    primary_object_id: payload.cardStackId,
    primary_object_id_and_ancestor_ids: models.cardStackIdAndAncestorIds,

    primary_verb: "download",
    primary_possessive: models.planbook
      ? getPossessiveForPlanbook(findFn, userId, models.planbook?.id)
      : "unknown",
    primary_object_type: "attachment",
    primary_object_specifier: null,

    adverbial_verb: null,
    adverbial_object_type: null,
    adverbial_object_specifier: null,
    adverbial_object_id: null,
    adverbial_possessive: null,
    adverbial_object_id_and_ancestor_ids: null,
  }

  return {
    title: "Downloaded Attachment",
    titleForAnalytics: "Attachment - Download",
    description: `Downloaded ${payload.attachment.type} Attachment`,
    activity: defaultLessonActivity(payload, models),
    context: context,
    newAnalyticsEvents: [newEvent],
  }
}
